import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Image, TextSubHeading, Link } from 'blocket-ui'

export const AdImage = ({ src, alt, children, width, height }) => {
  return (
    <ImageWrapper width={width}>
      <Image
        src={src}
        alt={alt}
        fit="cover"
        width={width}
        height={height}
        backgroundColor="transparent"
        backgroundSize="contain"
      >
        {children}
      </Image>
    </ImageWrapper>
  )
}

AdImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  src: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.node,
}

export const Wrapper = styled(Link)`
  display: block;
  padding: 16px;
  background: #f6f8fa;
  color: #363433;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border-bottom: 0.5px solid #e1e1e1;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 4px;
  border-radius: 2px;

  &:hover {
    color: #363433;
  }

  &:active {
    color: #363433;
  }

  &:last-child {
    border-bottom: 0;
  }
`
export const Article = styled.article`
  display: flex;
`
export const ImageWrapper = styled.div`
  min-width: ${(props) => (props.width ? props.width : '87')}px;
  position: relative;
  flex-shrink: 0;
  align-self: flex-start;
`

export const Content = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const Title = styled(TextSubHeading)`
  flex-grow: 1;
  max-height: 65px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  hyphens: auto;
  font-size: ${(props) => (props.ismobile ? '15px' : '17px')};
  color: #34689c;
  line-height: 26px;
`

export const BodyText = styled.span`
  font-size: ${(props) => (props.ismobile ? '12px' : '15px')};
  line-height: normal;
`

export const SubjectWrapper = styled.div`
  display: flex;
`

export const BodyWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 4px;
  color: #696766;
  font-size: ${(props) => (props.ismobile ? '12px' : '15px')};
`

export const BrandIcon = styled.div`
  align-self: flex-end;
`

export const BadgeWrapper = styled.div`
  flex-shrink: 0;
`
export const SponsoredByWrapper = styled.p`
  line-height: 20px;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  flex-grow: 1;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  text-transform: uppercase;
`
